<template>
  <EditorView v-if="this.report_data" />
</template>

<script>
import { ReportData } from "@/store/report/ReportData";
import { Rep_Step } from "@/store/report/SmallStorrage";
import EditorView from "@/components/Reports/editorView";

export default {
  name: "reportCreate",
  components: { EditorView },
  beforeMount() {
    if (!this.report_data) {
      Rep_Step().set(0)
      this.$router.push({ name: 'report__create'})
    }
  },
  computed: {
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  }
}
</script>